import React from 'react';
import { GREEN } from '../../HOME/const';

const SVG = ({ style = {}, color = GREEN, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} strokeWidth="8" strokeLinecap="round">
      <circle cx="50" cy="50" r="46" fill="none" />
      <circle cx="53" cy="17" r="7" strokeWidth="0" fill={color} />
      <line x1="32" y1="46" x2="35" y2="34" />
      <line x1="35" y1="34" x2="49" y2="30" />
      <line x1="49" y1="30" x2="48" y2="48" />
      <line x1="48" y1="48" x2="62" y2="60" />
      <line x1="62" y1="60" x2="68" y2="79" />

      <line x1="59" y1="44" x2="66" y2="49" />

      <line x1="45" y1="58" x2="40" y2="70" />
      <line x1="40" y1="70" x2="33" y2="80" />
    </g>
  </svg>
);

export default SVG;
